/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * AutoComplete CSS
 */
export const styles = css`
  :host {
    --virtual-scroll-container-width:110px;
    --virtual-scroll-container-height:200px;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .nile-dropdown--input {
    width: 100%;
  }

  .virtualized__menu{
    min-width: var(--virtual-scroll-container-width);
    min-height: var(--virtual-scroll-container-height) !important;
  }

  .virtualized__menu nile-menu-item{
    width:100%;
  }

  .nile-auto-complete--input {
    width: 100%;
  }

  .nile-auto-complete__label {
    display: block;
    color: var(--nile-colors-dark-900, var(--ng-colors-text-secondary-700));
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
    font-style: normal;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-medium));
    margin-bottom: var(--nile-spacing-sm, var(--ng-spacing-sm));
  }
  :host([required]) .nile-auto-complete__label::after {
    content: "*";
    color: var(--nile-colors-red-700, var(--ng-colors-text-error-primary-600));
    margin-inline-start: 2px;
  }
  :host([disabled]) {
    cursor: not-allowed;
    user-select: none;
    -webkit-user-select: none;
  }

  :host([disabled]) nile-input::part(base){
   pointer-events: none;
   background: var(--nile-colors-dark-200, var(--ng-colors-bg-disabled-subtle));
   color: var(--nile-colors-dark-500, var(--ng-colors-text-disabled));
  }


`;

export default [styles];
